import template   from './catalog-content.html'
import controller from './catalog-content.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/catalog-content/catalog-content.component.js